import { Injectable, ɵConsole } from "@angular/core";

import { BaseService } from "../abstracts/base.service";
import { StudentModel } from "../models/student.model";
import { AddressModel } from "../models/address.model";
import { ResultModel } from "../models/result.model";
import { map } from 'rxjs/operators';
import { ClassParticipantRoleModel } from "../models/classparticipantrole.model";

@Injectable({
  providedIn: "root",
})
export class StudentService extends BaseService {
  listAllForSelect(filter?: {ClassID?: string, TrainingID?: string, CompanyID?: string}) {
    if(filter == null || !(filter.ClassID || filter.TrainingID || filter.CompanyID ))
      return this.httpClient.get<ResultModel<StudentModel[]>>(this.getApiUrl("students"));
    else
      return this.httpClient.get<ResultModel<StudentModel[]>>(this.getApiUrl("students?") + this.getQueryString(filter));
  }

  listAll(formData?: FormData) {
    return this.httpClient.post<ResultModel<StudentModel[]>>(this.getApiUrl("students/list"), formData);
  }


  create(student: StudentModel, address: AddressModel, classID: string = '') {
    var queryParams = '';
    queryParams += this.getQueryString(address);

    if(classID){
      if(queryParams)
        queryParams += '&pClassID=' + classID;
      else
        queryParams += 'pClassID=' + classID;
    }

    if (queryParams == '') {
      return this.httpClient.post<ResultModel>(this.getApiUrl("students"), student);
    }
    else {
      return this.httpClient.post<ResultModel>(this.getApiUrl("students?" + queryParams), student);
    }
  }

  update(student: StudentModel, address?: AddressModel, classID: string = '', classStudentID:string='') {
    var queryParams = '';
    queryParams += this.getQueryString(address);

    if(classID){
      if(queryParams)
        queryParams += '&pClassID=' + classID;
      else
        queryParams += 'pClassID=' + classID;
    }

    if(classStudentID){
      if(queryParams)
        queryParams += '&pClassStudentID=' + classStudentID;
      else
        queryParams += 'pClassStudentID=' + classStudentID;
    }

    if (queryParams == '') {
      return this.httpClient.put<ResultModel>(this.getApiUrl("students"), student);
    }
    else {
      return this.httpClient.put<ResultModel>(this.getApiUrl("students?" + queryParams), student);
    }
  }

  get(id: string) {
    return this.httpClient.get<{ Student: StudentModel, Address: AddressModel, StudentUserIsActive: boolean, ClassID: any }>(this.getApiUrl("students/" + id));
  }

  getAll(studentID: string, trainingID: string = '') {
    return this.httpClient.get<{ Student: StudentModel, Address: AddressModel, StudentUserIsActive: boolean, ClassID: any, ClassStudentID:any }>(this.getApiUrl(`students/${studentID}/training/${trainingID}`));
  }

  delete(id: string,studentID:string ='') {
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`students/${id}/training/${studentID}`));
  }


  /**
   * Öğrencinin avatar resmini günceller
   * @param base64Image Avatar image
   */
  changeProfilePhoto(id: string, base64Image: string){
    var formData = new FormData;

    formData.append('img', base64Image);
    formData.append('format', 'PNG');

    return this.httpClient.post<ResultModel>(this.getApiUrl(`students/${id}/change-avatar`), formData)
  }

  deleteProfilePhoto(id: string){
    return this.httpClient.delete<ResultModel>(this.getApiUrl(`students/${id}/delete-avatar`));
  }

  listAllAccounts(formData?: FormData) {
    return this.httpClient.post<ResultModel<StudentModel[]>>(this.getApiUrl("students/list/accounts"), formData);
  }

  getStudentForClass(companyID = null, trainingID = null, classID = null) {
    var queryParams = {
      pCompanyID: companyID,
      pTrainingID: trainingID,
      pClassID: classID
    }

    let queryString = this.getQueryString(queryParams);

    if(queryString){
      queryString = '?' + queryString;
    }
    return this.httpClient.get<{ Participant: StudentModel[], ParticipantRole: ClassParticipantRoleModel[], ParticipantRoleStatus:any[] }>(this.getApiUrl('students/getlist' + queryString));
  }

  


}
